webpackJsonp([70144966829960],{

/***/ 355:
/***/ (function(module, exports) {

	module.exports = {"m@matchilling.com":"-----BEGIN PGP PUBLIC KEY BLOCK-----\nVersion: GnuPG v1\nmQENBFeUtcABCADYMKQ3jBsZIm8qPWYx+UA/21OIJ4lFq0O+CYutjfTRmoau89IY\n1bZeQd5JgLSFGBP+NyECG5inB6FzB5esNuK3bHFwuyEYqL1zCd/+h1kaD0FLls3G\n2Z+rZw2Xq3h2p31Kv+4nbaUg+cEqSY0jzpULAZxImj2mWvWjX9UPgVFFFrJ29qfv\nVfv1PtkwhVa3lQgDN9OWEqCHbq6QdcNlJE5NVLLk/gMwuvNgRowvRr9Apywkqnpa\nmRG8xfw1a3JTyOt4aAjzhsOQsZC+nz4oMCoyaD3sYrQG7C6OKd30IcAElIOrhUy8\nrzSNgBcP967GHSfd3GdZjfE/822q9DF4pt43ABEBAAG0JU1hdGhpYXMgU2NoaWxs\naW5nIDxtQG1hdGNoaWxsaW5nLmNvbT6JATgEEwECACIFAleUtcACGwMGCwkIBwMC\nBhUIAgkKCwQWAgMBAh4BAheAAAoJEOxsUDjfs0wfm/IIALRg0+dHQLuuDIe9VFNU\nU8ZDqaNkzMBUPAVAI54pvUg5GZJdimhvvhL8eEsRC7apODZ4Q5tN39VIU27Pe43a\nSrMYoI1nDmUnfQMwzY45S9i2Q6YlE7y5njHuQsfLyaKmZB2jq3s8TeFunYOukvjY\n5ol0eqW2i/1h/YqjZOKPJ1iff5sMavP/x7/LVCBr+e6aRZeA8n1NccuHcAnz1r71\n+z+xb4K+xN+ADKA+O5ax74sdy3hNBwGHuMeWwaom9lQlNsc+XEHJuNY/vtnUWxE+\nEMTZNVZd41Z1+jnjPST25vHVTTD0NQyarOuzwJQ6RSpn8ThhvOMNsf4xrRlvI0X3\n0Mm5AQ0EV5S2igEIAMNl9gd02TKGukvob8zA042Q0Pe35ebZ4tHMgNgSo+lUM/5U\nOcqlWymiWxce3vTxlS1uiSFVber5C7hwGnuIHZBZdRfpDEOViQ5fXC8sF04+Y0qG\nQ99keoE89lcmwFSL85lLKgIHF/AluhPN2YimtZ1TFgVq/ESMYoasksImj6x3gRpl\ngag2sFrrTR71UTBORaOsME2ec3dMQ3I85OWwEA/eBokrv2Wo3qvvVyD2MRrvhgHq\nd2GIosHaJ2ksyo+CaKdIzShkWWVIA6gGhwv0NqY/mJpnxRezeebBMHngZHzgyuBf\ndPLA7Hv86dgQNdpG2d+LeSOcwqnX35tSn7c2CPsAEQEAAYkBHwQYAQIACQUCV5S2\nigIbDAAKCRDsbFA437NMH3rYCADOkOv4VHr0X0/OhAM6yCGEkQ3592q6E9dYJ9Nz\n+d5E03tD+HyyiM4G1qM4FpFCHYd8s+UPb2pJCsjEUtOOCKKUOpQ71xJJv8KfrptD\nPvLl5HlAe6FPWAn0FySbEBIczAeLKcPE082KewTqYdaNmXLGdp3p/+X3JYsQek81\n8oLH5PFBjxPJ09l6ZK6EmlvU+SxwBPpI1kG3aUa40aDRWQshTv+0UGVIA5rIEa9y\nKixt0bhYQiTAa/Mjjf8wXg7rCcDk3aNkOgsDphZ2ggtCw5SJ5hehIQ/DR1FuLfU+\nWj/REMUvahB81N8DWcanBBEtakyBrg/WRoYaJFVSBykdMayX\n=PtF8\n-----END PGP PUBLIC KEYBLOCK-----"}

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	module.exports = {"name":"Mathias Schilling","contact":{"email":"m@matchilling.com","github":"https://github.com/matchilling","instagram":"https://www.instagram.com/matchilling/","lastfm":"https://www.last.fm/user/msatlastfm","linkedin":"https://www.linkedin.com/in/matchilling","reddit":"https://www.reddit.com/user/matchilling","twitter":"https://twitter.com/MatChilling"}}

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _profile = __webpack_require__(36);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _profile3 = __webpack_require__(56);
	
	var _profile4 = _interopRequireDefault(_profile3);
	
	var _typography = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Biography = function (_React$Component) {
	  _inherits(Biography, _React$Component);
	
	  function Biography() {
	    _classCallCheck(this, Biography);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Biography.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { style: { display: 'flex' } },
	      _react2.default.createElement('img', {
	        alt: _profile2.default.name,
	        src: _profile4.default,
	        style: {
	          height: (0, _typography.rhythm)(3),
	          marginBottom: 0,
	          marginRight: (0, _typography.rhythm)(1 / 2),
	          width: (0, _typography.rhythm)(3)
	        }
	      }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'I create',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://jugendstil.io/' },
	          'business impact through code'
	        ),
	        ' and help organisations become more effective in delivering solutions to their customer\'s problems. You can find me on',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: _profile2.default.contact.twitter, target: '_blank' },
	          'Twitter'
	        ),
	        ',',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: _profile2.default.contact.linkedin, target: '_blank' },
	          'LinkedIn'
	        ),
	        ',',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: _profile2.default.contact.github, target: '_blank' },
	          'GitHub'
	        ),
	        ',',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: _profile2.default.contact.reddit, target: '_blank' },
	          'Reddit'
	        ),
	        ', and',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: _profile2.default.contact.lastfm, target: '_blank' },
	          'Last.fm'
	        ),
	        '.'
	      )
	    );
	  };
	
	  return Biography;
	}(_react2.default.Component);
	
	exports.default = Biography;
	module.exports = exports['default'];

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactHelmet = __webpack_require__(54);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(60);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _biography = __webpack_require__(43);
	
	var _biography2 = _interopRequireDefault(_biography);
	
	var _profile = __webpack_require__(36);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _pgp_keys = __webpack_require__(355);
	
	var _pgp_keys2 = _interopRequireDefault(_pgp_keys);
	
	var _typography = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contact = function (_React$Component) {
	  _inherits(Contact, _React$Component);
	
	  function Contact() {
	    _classCallCheck(this, Contact);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Contact.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: 'Contact',
	        meta: [{
	          name: 'description',
	          content: '99% of the time my brain is thinking blah, meh, why, huh, WTF, food and programming. The other 1% I’m usually asleep.'
	        }]
	      }),
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Contact'
	      ),
	      _react2.default.createElement(_biography2.default, null),
	      _react2.default.createElement(
	        'p',
	        null,
	        '... or drop me a line at ',
	        _profile2.default.contact.email
	      ),
	      _react2.default.createElement('hr', { style: { marginBottom: (0, _typography.rhythm)(1) } }),
	      _react2.default.createElement(
	        'pre',
	        { style: { marginBottom: (0, _typography.rhythm)(1), textAlign: 'center' } },
	        _pgp_keys2.default[_profile2.default.contact.email]
	      )
	    );
	  };
	
	  return Contact;
	}(_react2.default.Component);
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-a34f68c3dc79435f7bee.js